import { render, staticRenderFns } from "./StarRatingModV2.vue?vue&type=template&id=634627cf"
import script from "./StarRatingModV2.vue?vue&type=script&lang=js"
export * from "./StarRatingModV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports